import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useJxcModel } from "../jxcModel";
import { ISCMJxcDetail } from "../jxcService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";
import YhTootip from "@/components/YhTootip";
import useGlobalModel from "@/model/globalModel";




export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        setHistoryVisible,
        setHistoryRow, descTotal
    } = useJxcModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    const onHistoryModel = (record: ISCMJxcDetail) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<ISCMJxcDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '商品编号',
            width: 200,
            dataIndex: 'materialCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); onHistoryModel(record) }}>{text}</p></Tooltip>,
        }, {
            title: '商品名称',
            width: 200,
            dataIndex: 'materialName',
        }, {
            title: '商品类型',
            width: 120,
            dataIndex: 'typeName',
        },
        // {
        //     title: '替换编号',
        //     width: 200,
        //     dataIndex: 'replaceCode',
        // }, {
        //     title: '最新进价',
        //     width: 120,
        //     dataIndex: 'lastestPrice',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, {
        //     title: '期初数量',
        //     width: 120,
        //     dataIndex: 'startNum',
        // }, {
        //     title: '期初成本',
        //     width: 120,
        //     dataIndex: 'startAmount',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, 
        {
            title: '期末数量',
            width: 120,
            dataIndex: 'inventoryNum',
        }, {
            title: '期末成本',
            width: 120,
            dataIndex: 'lastestPriceAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        }, {
            title: '本期入数',
            width: 120,
            dataIndex: 'warehousingInNum',
        }, {
            title: '本期入金额',
            width: 120,
            dataIndex: 'warehousingInAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        }, {
            title: '本期出数',
            width: 120,
            dataIndex: 'warehouseOutNum',
        }, {
            title: '本期出金额',
            width: 120,
            dataIndex: 'warehouseOutAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        }, {
            title: '采购数量',
            width: 120,
            dataIndex: 'purchaseNum',
        }, {
            title: '采购金额',
            width: 120,
            dataIndex: 'purchaseAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        }, {
            title: '采退数量',
            width: 120,
            dataIndex: 'preturnNum',
        }, {
            title: '采退金额',
            width: 120,
            dataIndex: 'preturnAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        }, {
            title: '销售数量',
            width: 120,
            dataIndex: 'saleNum',
        }, {
            title: '销售金额',
            width: 120,
            dataIndex: 'saleAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        },
        //  {
        //     title: '销售成本',
        //     width: 120,
        //     dataIndex: 'saleCost',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, {
        //     title: '销售毛利',
        //     width: 120,
        //     dataIndex: 'saleGrossProfit',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, 
        {
            title: '销退数量(含赠品)',
            width: 140,
            dataIndex: 'sreturnNum',
        }, {
            title: '销退金额',
            width: 120,
            dataIndex: 'sreturnAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        },
        //  {
        //     title: '销退成本',
        //     width: 120,
        //     dataIndex: 'sreturnCost',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, 
        // {
        //     title: '销退毛利',
        //     width: 120,
        //     dataIndex: 'sreturnGrossProfit',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, 
        {
            title: '维修数量',
            width: 120,
            dataIndex: 'maintenanceNum',
        },
        {
            title: '维修金额',
            width: 120,
            dataIndex: 'maintenanceAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        },
        // {
        //     title: '维修成本',
        //     width: 120,
        //     dataIndex: 'maintenanceCost',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, {
        //     title: '维修毛利',
        //     width: 120,
        //     dataIndex: 'maintenanceGrossProfit',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // },
        {
            title: '维退数量',
            width: 120,
            dataIndex: 'maintenanceReturnNum',
            render: (text) => `￥${formatNum(text ?? 0)}`
        },
        {
            title: '维退金额',
            width: 120,
            dataIndex: 'maintenanceReturnAmount',
            render: (text) => `￥${formatNum(text ?? 0)}`
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopId',
            render: (text) => allShopDs.find((item: any) => item.value == text)?.label
        }
        // {
        //     title: '维退成本',
        //     width: 120,
        //     dataIndex: 'maintenanceReturnCost',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, {
        //     title: '维退毛利',
        //     width: 120,
        //     dataIndex: 'maintenanceReturnGrossProfit',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // },
        // {
        //     title: '盘盈数量',
        //     width: 120,
        //     dataIndex: 'surplusNum',
        // }, {
        //     title: '盘盈金额',
        //     width: 120,
        //     dataIndex: 'surplusAmount',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // }, {
        //     title: '盘亏数量',
        //     width: 120,
        //     dataIndex: 'lossNum',
        // }, {
        //     title: '盘亏金额',
        //     width: 120,
        //     dataIndex: 'lossAmount',
        //     render: (text) => `￥${formatNum(text ?? 0)}`
        // },  {
        //     title: '仓库',
        //     width: 120,
        //     dataIndex: 'warehouseName',
        // }, {
        //     title: '货位',
        //     width: 120,
        //     dataIndex: 'shelfCode',
        // }, {
        //     title: '季销存率',
        //     width: 100,
        //     dataIndex: 'name',
        // }, {
        //     title: '年销存率',
        //     width: 100,
        //     dataIndex: 'name',
        // }, {
        //     title: '积压率',
        //     width: 100,
        //     dataIndex: 'name',
        // }, {
        //     title: '年周转率',
        //     width: 100,
        //     dataIndex: 'name',
        // }
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        // setSelectedRow(record)
        // console.log(id)
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            rowSelection={{
                selectedRowKeys: selectedRowKeys, //记录选中
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 370px)" }}
        // summary={() => (
        //     <Table.Summary fixed>
        //         <Table.Summary.Row className="table-total-box">
        //             <Table.Summary.Cell index={0}>
        //                 <div className="title">合计</div>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={1} />
        //             <Table.Summary.Cell index={2} />
        //             <Table.Summary.Cell index={3} />
        //             <Table.Summary.Cell index={4} />
        //             <Table.Summary.Cell index={5}>
        //                 <span className="red">{descTotal.inventoryNum ?? 0}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={6}>
        //                 <span className="red">{descTotal.lastestPriceAmount ?? 0}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={7}>
        //                 <span className="red">{descTotal.warehousingInNum}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={8}>
        //                 <span className="red">{descTotal.warehousingInAmount}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={9}>
        //                 <span className="red">{descTotal.warehouseOutNum}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={10}>
        //                 <span className="red">{descTotal.warehouseOutAmount}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={11} />
        //             <Table.Summary.Cell index={12} />
        //             <Table.Summary.Cell index={13} />
        //             <Table.Summary.Cell index={14} />
        //             <Table.Summary.Cell index={15} />
        //             <Table.Summary.Cell index={16} />
        //             <Table.Summary.Cell index={17} />
        //             <Table.Summary.Cell index={18} />
        //             <Table.Summary.Cell index={19} />
        //             <Table.Summary.Cell index={20} />
        //             <Table.Summary.Cell index={21} />
        //             <Table.Summary.Cell index={22} />
        //             <Table.Summary.Cell index={23} />
        //         </Table.Summary.Row>
        //     </Table.Summary>
        // )}
        />
    )
}